import * as actionTypes from 'constants/ActionTypes';
import difference from 'lodash/difference';
import union from 'lodash/union';

const areas = (state = {
    suggestions: [],
    searchText: '',
    items: [],
    isLoaded: false,
    isUpdating: false,
}, action) => {
    switch (action.type) {
    case actionTypes.GET_AREAS.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_AREAS.SUCCESS: {
        const items = action.data.map(item => ({
            ...item,
            isUpdate: false,
            prevState: item,
        }));

        return {
            ...state,
            items,
            isLoaded: true,
        };
    }
    case actionTypes.GET_AREAS.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
    case actionTypes.SEARCH_AREA:
        return {
            ...state,
            searchText: action.search,
        };
    case actionTypes.SAVE_AREA: {
        const items = state.items.map((item) => {
            if (item._id === action.item._id) {
                return {
                    ...item,
                    isUpdate: true,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_AREA_SUGGESTIONS: {
        return {
            ...state,
            suggestions: action.suggestions,
        };
    }
    case actionTypes.UPDATE_AREA_ALT.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_AREA_ALT.SUCCESS: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...action.item,
                    prevState: action.item,
                    isUpdate: false,
                };
            }
            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_AREA_ALT.FAILURE: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: true,
                    errors: action.item.errors,
                };
            }
            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_AREA.REQUEST: {
        return {
            ...state,
            isUpdating: true,
        };
    }
    case actionTypes.UPDATE_AREA.SUCCESS: {
        const oldItem = state.items.find(i => i._id === action.item._id);
        const newChilds = action.item.childs
            ? difference(action.item.childs, oldItem.childs)
            : [];
        const removedChilds = action.item.childs
            ? difference(oldItem.childs, action.item.childs)
            : [];
        const newParents = action.item.parents
            ? difference(action.item.parents, oldItem.parents)
            : [];
        const removedParents = action.item.parents
            ? difference(oldItem.parents, action.item.parents)
            : [];
        const items = state.items.map((item) => {
            if (item._id === action.item._id) {
                return {
                    ...item,
                    ...action.item,
                };
            }
            if (newChilds.includes(item._id)) { // item is added to childs
                return {
                    ...item,
                    parents: union(item.parents, [action.item._id]),
                };
            }
            if (removedChilds.includes(item._id)) { // item is removed from childs
                return {
                    ...item,
                    parents: item.parents.filter(id => id !== action.item._id),
                };
            }
            if (newParents.includes(item._id)) { // item is added to parents
                return {
                    ...item,
                    childs: union(item.childs, [action.item._id]),
                };
            }
            if (removedParents.includes(item._id)) { // item is removed from parents
                return {
                    ...item,
                    childs: item.childs.filter(id => id !== action.item._id),
                };
            }
            return item;
        });
        return {
            ...state,
            items,
            isUpdating: false,
        };
    }
    case actionTypes.UPDATE_AREA.FAILURE: {
        return {
            ...state,
            isUpdating: false,
        };
    }
    case actionTypes.REMOVE_AREA_CHILD.REQUEST: {
        return {
            ...state,
            isUpdating: true,
        };
    }
    case actionTypes.REMOVE_AREA_CHILD.FAILURE: {
        return {
            ...state,
            isUpdating: false,
        };
    }
    case actionTypes.REMOVE_AREA_CHILD.SUCCESS: {
        const items = state.items.map((item) => {
            if (item._id === action.parentId) {
                return {
                    ...item,
                    childs: item.childs.filter(id => id !== action.childId),
                    childAreaCount: item.childAreaCount - 1,
                };
            }
            if (item._id === action.childId) {
                return {
                    ...item,
                    parents: (item.parents || []).filter(id => id !== action.parentId),
                };
            }
            return item;
        });
        return {
            ...state,
            items,
            isUpdating: false,
        };
    }
    case actionTypes.DELETE_AREA.REQUEST: {
        return {
            ...state,
        };
    }
    case actionTypes.DELETE_AREA.SUCCESS: {
        const items = state.items.filter((item) => {
            return item._id !== action.item._id;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.DELETE_AREA.FAILURE: {
        return {
            ...state,
        };
    }
    case actionTypes.CREATE_AREA.REQUEST: {
        return {
            ...state,
        };
    }
    case actionTypes.CREATE_AREA.SUCCESS: {
        const { items } = state;
        items.push(action.item);

        return {
            ...state,
            items,
        };
    }
    case actionTypes.CREATE_AREA.FAILURE: {
        return {
            ...state,
        };
    }
    default:
        return state;
    }
};

export default areas;



// WEBPACK FOOTER //
// ./app/reducers/regions/areas.js